webpackJsonp([475],{

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(2368),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/2.9.3-62.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] 2.9.3-62.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e4f64ef", Component.options)
  } else {
    hotAPI.reload("data-v-7e4f64ef", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2368:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 2.9.3 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix Uncaught TypeError: Cannot assign to read only property exports of object #3386")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix the chinese bracket show error when direction=rtl #2864")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/v-chart.html"
    }
  }, [_vm._v("VChart")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] v-point can set size and shape, v-line can set shape")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e4f64ef", module.exports)
  }
}

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1689);

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 2.9.3 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 475.a32de8b8.js